import Ajax from "base/Ajax";
import $ from "jquery";
import moment from "moment";
import queryString from "query-string";

class NewsAndEventsHandler {
    constructor() {
        this.bindEvents();
    }

    bindEvents() {
        const me = this;
        $("body").on("click", ".js-pagination-link", function () {
            me.loadPage(parseInt($(this).attr("data-page")));

            return false;
        }).on("change", ".js-category-filter", function () {
            let val = $(this).val();
            me.setCategory(val === "" ? undefined : val)
        });

        $(window).on("scroll resize", () => {
            this.updateStickyLoader();
            this.updateStickySidebar();
        });

        this.updateStickyLoader();
        this.updateStickySidebar();

        window.onpopstate = () => {
            let query = queryString.parse(window.location.search);

            this.category = query['filter'];
            let page = 'undefined' === typeof query['page'] ? 1 : parseInt(query['page']);

            let categoryVal = 'undefined' === typeof this.category ? '' : this.category;
            $(".js-category-filter[value='" + categoryVal + "']").prop("checked", true);

            this.loadPage(page, false);
        }
    }

    updateStickyLoader() {
        let $header = $(".header");
        let $list = $(".article-list");
        let $loader = $(".article-list__loader-icon");

        let scrollTop = $(window).scrollTop() + $header.position().top + $header.outerHeight();
        let scrollCenter = scrollTop + ($(window).height() / 2);

        let listTop = $list.offset().top;
        let listBottom = listTop + $list.outerHeight();

        let loaderTop = listTop + 250;

        if (scrollCenter < loaderTop) {
            //At top
            $loader.removeClass("article-list__loader-icon--bottom article-list__loader-icon--sticky").addClass("article-list__loader-icon--top").css("left", "");
        } else if (scrollCenter > listBottom) {
            //At bottom
            $loader.removeClass("article-list__loader-icon--top article-list__loader-icon--sticky").addClass("article-list__loader-icon--bottom").css("left", "");
        } else {
            //Sticky
            $loader.removeClass("article-list__loader-icon--top article-list__loader-icon--bottom").addClass("article-list__loader-icon--sticky").css("left", $list.offset().left + $list.width() / 2);
        }
    }

    updateStickySidebar() {
        let $sidebar = $(".upcoming");
        if ($sidebar.length !== 1) return;

        let $header = $(".header");
        let headerHeight = $header.position().top + $(".wrapper").height();

        if ($(window).outerWidth() < 960 || $(window).height() < $sidebar.outerHeight() + headerHeight) {
            $sidebar.removeClass("upcoming--bottom upcoming--top upcoming--sticky").css("left", "").css("width", "");
            return;
        }

        let $list = $(".js-article-list");

        let scrollTop = $(window).scrollTop() + headerHeight;
        let scrollBottom = scrollTop + $sidebar.outerHeight() + 20;

        let listTop = $list.offset().top;
        let listBottom = listTop + $list.outerHeight();

        if (scrollTop < listTop) {
            //At top
            $sidebar.removeClass("upcoming--bottom upcoming--sticky").addClass("upcoming--top").css("left", "").css("width", "");
        } else if (scrollBottom > listBottom) {
            //At bottom
            $sidebar.removeClass("upcoming--top upcoming--sticky").addClass("upcoming--bottom").css("left", "").css("width", "");
        } else {
            //Sticky

            let maxWidth = $sidebar.css("max-width");
            let widthParts = /^([0-9.]+)%$/.exec(maxWidth);

            let $wrap = $(".news-and-events__flex");

            let wrapWidth = $wrap.outerWidth();
            let width = widthParts === null ? '' : (parseFloat(widthParts[1]) / 100 * wrapWidth + "px");

            if(width === '') {
                $sidebar.removeClass("upcoming--sticky");
                width = $sidebar.outerWidth();
            }

            $sidebar.removeClass("upcoming--top upcoming--bottom").css("width", width).css("left", wrapWidth + $wrap.offset().left - parseFloat($sidebar.width())).addClass("upcoming--sticky");
        }
    }

    loadPage(page, pushState = true) {
        if (this.request) this.request.abort();

        if (pushState) {
            try {
                let stateParts = {};

                if (page != 1) {
                    stateParts['page'] = page;
                }
                if ('undefined' !== typeof this.category) {
                    stateParts['filter'] = this.category;
                }
                let stateUrl = $.param(stateParts);
                history.pushState({}, '', '/news-and-events' + (stateUrl !== '' ? '?' + stateUrl : ''));
            } catch (e) {

            }
        }

        let request = Ajax.get("content", '968c1450cc2bddcd/posts/search', {
            page,
            limit: NewsAndEventsHandler.LIMIT,
            category: this.category
        }, Ajax.WEBSITE);
        this.request = request;

        let $list = $(".js-article-list");
        $list.addClass("article-list--loading");

        request.then((result) => {
                if (result.pages.totalResults === 0) {
                    $list.html(eotwJSXFactory('p', null, ["There are no results to show..."]));
                    return;
                }

                $list.html(result.results.map((result) => {
                    let category = result.activeRevision.values.category[0];
                    let category_slug = 'object' === typeof category && category !== null ? category.slug : 'news';
                    let category_name = 'object' === typeof category && category !== null ? category.name : 'News';

                    let image = result.activeRevision.values['header-image'];

                    let start_date = result.activeRevision.values['start-date'];
                    let end_date = result.activeRevision.values['end-date'];

                    if (!start_date) start_date = end_date;
                    if (!end_date) end_date = start_date;

                    return (
                        eotwJSXFactory('article', {class: "article article--news-and-events"}, [
                            eotwJSXFactory('a', {href: result.url}, [
                                eotwJSXFactory('aside', {class: "article__image"}, [
                                    eotwJSXFactory('span', {class: "article__image-wrap article__image-wrap--" + category_slug + " " + (image !== null ? 'article__image-wrap--has-image' : '')}, [
                                        image !== null ? (
                                            eotwJSXFactory('img', {'data-object-fit': "cover", src: image.versions['5' /*MEDIUM*/].url, srcset: image.srcset})
                                        ) : []
                                    ])
                                ]),
                                eotwJSXFactory('div', {class: "article__body"}, [
                                    eotwJSXFactory('h5', null, [
                                        eotwJSXFactory('span', {href: result.url, class: "article__header-link"}, [result.activeRevision.values.title])
                                    ]),
                                    eotwJSXFactory('div', {unsafeHtml: result.activeRevision.values.snippet}),
                                    eotwJSXFactory('span', {class: "article__read-more"}, ["Read more..."]),
                                    eotwJSXFactory('footer', {class: "article__footer"}, [
                                        eotwJSXFactory('div', {class: "article__footer-info article__footer-time"}, [
                                            eotwJSXFactory('span', {class: "svg-icon article__footer-icon"}).html('<svg><use xlink:href="/includes/svg-icons.svg#clock"></use>'),
                                            eotwJSXFactory('time', {class: "article__footer-text"}, [moment.unix(result.dateCreated.timestamp).format('dddd Do MMMM YYYY')])
                                        ]),
                                        eotwJSXFactory('div', {class: "article__footer-info"}, [
                                            eotwJSXFactory('span', {class: "svg-icon article__footer-icon"}).html('<svg><use xlink:href="/includes/svg-icons.svg#' + category_slug + '"></use>'),

                                            eotwJSXFactory('span', {class: "article__footer-text"}, [category_name])
                                        ]),
                                        category_slug === 'events' && start_date && end_date ? (
                                            eotwJSXFactory('div', {class: "article__footer-info"}, [
                                                eotwJSXFactory('span', {class: "svg-icon article__footer-icon article__footer-icon--red"}).html('<svg><use xlink:href="/includes/svg-icons.svg#events"></use></svg>'),
                                                eotwJSXFactory('strong', {class: "article__footer-text article__footer-text--event-date"}, [
                                                    moment.unix(start_date.timestamp).format('Do MMMM'),
                                                    start_date.timestamp === end_date.timestamp ? '' : ' - ' + moment.unix(end_date.timestamp).format('Do MMMM')
                                                ])
                                            ])
                                        ) : undefined
                                    ])
                                ])
                            ])
                        ])
                    );
                }));

                let base_url = '?fitler=' + this.category + '&page=';
                let $pagination = (
                    result.pages.max > 1 ? (
                        eotwJSXFactory('div', {class: "pagination"}, [
                            page > 1 ? (
                                eotwJSXFactory('a', {href: base_url + (page - 1), class: "pagination__previous-next js-pagination-link", 'data-page': page - 1}, [
                                    eotwJSXFactory('span', {class: "svg-icon"}).html('<svg><use xlink:href="/includes/svg-icons.svg#arrow"></use></svg>'),
                                    eotwJSXFactory('span', null, ["Previous"])
                                ])
                            ) : [],


                                (() => {
                                    let items = [];

                                    let start = Math.max(1, page - 4);
                                    let end = Math.min(result.pages.max, page + 4);

                                    if (start !== 1) {
                                        items.push(
                                            eotwJSXFactory('li', {class: "pagination__item js-more-pagination-btn", 'data-position': "start"}, [
                                                eotwJSXFactory('button', {class: "pagination__link"}, ["..."])
                                            ])
                                        )
                                    }

                                    for (let i = start; i <= end; i++) {
                                        items.push(
                                            eotwJSXFactory('li', {class: "pagination__item"}, [eotwJSXFactory('a', {href: base_url + i, 'data-page': i, class: "pagination__link js-pagination-link " + ( i == page ? 'pagination__link--active' : '')}, [i])])
                                        );
                                    }

                                    if (end !== result.pages.max) {
                                        items.push(
                                            eotwJSXFactory('li', {class: "pagination__item js-more-pagination-btn", 'data-position': "end"}, [
                                                eotwJSXFactory('button', {class: "pagination__link"}, ["..."])
                                            ])
                                        )
                                    }

                                    return items;
                                })(),


                            page < result.pages.max ? (
                                eotwJSXFactory('a', {href: base_url + (page + 1), class: "pagination__previous-next pagination__previous-next--next js-pagination-link", 'data-page': page + 1}, [
                                    eotwJSXFactory('span', {class: "svg-icon"}).html('<svg><use xlink:href="/includes/svg-icons.svg#arrow"></use></svg>'),
                                    eotwJSXFactory('span', null, ["Next"])
                                ])
                            ) : []
                        ])
                    ) : (eotwJSXFactory('div', {class: "pagination"}))
                );

                $list.append($pagination).removeClass("article-list--loading").append(
                    eotwJSXFactory('span', {class: "article-list__loader"}, [
                        eotwJSXFactory('span', {class: "article-list__loader-icon"})
                    ])
                );
                if (pushState) {
                    $(window).scrollTop($(".filter").offset().top - $(".header").position().top - $(".header").outerHeight() - 30);
                }
                this.updateStickyLoader();
            }
        ).catch((e) => {
            $list.removeClass("article-list--loading").html(
                eotwJSXFactory('div', {class: "message"}, [
                    eotwJSXFactory('span', {class: "svg-icon message__icon"}).html('<svg><use xlink:href="/includes/svg-icons.svg#threat-icon"></use></svg>'),
                    eotwJSXFactory('p', null, [e.message])
                ])
            ).append(
                eotwJSXFactory('span', {class: "article-list__loader"}, [
                    eotwJSXFactory('span', {class: "article-list__loader-icon"})
                ])
            );
        });

        return request;
    }

    setCategory(category) {
        this.category = category;

        return this.loadPage(1);
    }
}

NewsAndEventsHandler.LIMIT = 8;

export default NewsAndEventsHandler;
